import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Trusted by Skiers & Snowboarders Everywhere | ShipSkis',
  description:
    "Don't take our word for it - see what real users have to say about their experience " +
    'shipping skis and snowboards with ShipSkis.',
  alternates: {
    canonical: 'https://www.shipskis.com/reviews',
  },
}

export default metadata
